import React from 'react';
import FeaturedSVG from '../assets/FeaturedLogo.svg';
import { Box, Typography, Container } from '@mui/material';
import { keyframes } from '@emotion/react';

import ConveyerBeltPhoto from '../assets/ScaleImages/Conveyer Belt System.webp';
import JwelleryweighingScalePhoto from '../assets/ScaleImages/JwelleryScale.webp';
import PlatformWeighingPhoto from '../assets/ScaleImages/PlatformScale.webp';
import KitchenScalePhoto from '../assets/ScaleImages/KitchenScale.webp';
import TableTopWeighingPhoto from '../assets/ScaleImages/TabeTopScale.webp';
import TankWeighingPhoto from '../assets/ScaleImages/Tank Weighing System.webp';
import WeighBridgePhoto from '../assets/ScaleImages/Weigh Bridge.jpg';
import PLCAutomationPhoto from '../assets/ScaleImages/SmartIndicator.webp';
import IOTweighingSystemPhoto from '../assets/ScaleImages/Smart IOT Automation.webp';

const images = [
  PlatformWeighingPhoto,
  ConveyerBeltPhoto,
  KitchenScalePhoto,
  TableTopWeighingPhoto,
  TankWeighingPhoto,
  JwelleryweighingScalePhoto,
  WeighBridgePhoto,
  PLCAutomationPhoto,
  IOTweighingSystemPhoto
];

// Define keyframes for the marquee animation
const scrollX = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const Gallery = () => {
  // Duplicate images to create a seamless loop
  const marqueeImages = [...images, ...images];

  return (
    <Box sx={{ py: 8, backgroundColor: '#f9f9f9', overflow: 'hidden' }}>
      <Container maxWidth="lg" sx={{ textAlign: 'center', mb: 6 }}>
        <Box component="img" src={FeaturedSVG} alt="Featured SVG" sx={{ width: '100%', maxWidth: '400px', height: 'auto', mb: 2 }} />
        <Typography
          variant="h3"
          sx={{
            color: '#B1B1B1',
            fontFamily: 'Inter, sans-serif',
            fontSize: '24px',
            fontWeight: 400,
            textTransform: 'uppercase',
            letterSpacing: '2px',
            mb: 2
          }}
        >
          OUR GALLERY
        </Typography>
      </Container>

      {/* Marquee Container */}
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          overflow: 'hidden',
          '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            width: '150px',
            height: '100%',
            zIndex: 2,
            pointerEvents: 'none'
          },
          '&::before': {
            left: 0,
            background: 'linear-gradient(to right, #f9f9f9, transparent)'
          },
          '&::after': {
            right: 0,
            background: 'linear-gradient(to left, #f9f9f9, transparent)'
          }
        }}
      >
        {/* Scrolling Track */}
        <Box
          sx={{
            display: 'flex',
            width: 'max-content',
            animation: `${scrollX} 40s linear infinite`,
            '&:hover': {
              animationPlayState: 'paused'
            }
          }}
        >
          {marqueeImages.map((image, index) => (
            <Box
              key={index}
              sx={{
                flexShrink: 0,
                px: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Box
                component="img"
                src={image}
                alt={`Gallery Image ${index}`}
                sx={{
                  height: { xs: '200px', md: '300px' },
                  width: 'auto',
                  borderRadius: '16px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.05)',
                    boxShadow: '0 15px 40px rgba(0,0,0,0.15)'
                  }
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Gallery;
